import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import qs from 'qs';
import Search from '@/components/SearchV3/index.vue';
import { taskSearchField, timeFilterOptions } from '@/common/material-metadata';
import { sourceList } from '@/common/demand';
import { v2Host } from '@/config/host';
import { downloadWithNewWindow } from '@/common/download.js';
import { cookRequestParams } from '@/common/request';
import { platform } from '@/common/platform';

export default {
  components: {
    Search: Search
  },

  props: {
    query: Object,

    handleSearch: Function,

    handleResetSearch: Function,

    formItems: Array,

    columnConfig: Array,

    showExport: Boolean,
    keyField: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      // 通过父级传入search_field配置项
      keyFieldConfig: this.keyField.length > 0 ? this.keyField : taskSearchField,
      creativeProvider: []
    };
  },


  computed: {
    // 根据 formItems 过滤表单项
    formItemList: function formItemList() {
      var _this = this;

      return [{
        prop: 'search_field',
        type: 'select',
        params: {
          clearable: false,
          filterable: true,
          style: 'width: 220px;',
          options: this.keyFieldConfig,
          placeholder: '请选择搜索类型'
        }
      }, {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref) {
          var formValue = _ref.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: formValue.search_field ? '按' + _this.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入关键字'
          };
        }
      }, {
        type: 'business',
        subtype: 'app-category-selector',
        prop: 'app_cat_ids',
        params: {
          style: 'width: 220px;',
          disabled: false,
          multiple: true,
          clearable: true,
          collapseTags: true,
          filterable: true,
          placeholder: '请选择app分类',
          class: 'search-filter-select'
        }
      }, {
        type: 'business',
        subtype: 'category-selector',
        prop: 'category_ids',
        params: {
          style: 'width: 220px;',
          multiple: true,
          disabled: false,
          clearable: true,
          collapseTags: true,
          placeholder: '请选择素材类别',
          class: 'search-filter-select'
        }
      }, {
        type: 'business',
        subtype: 'test-status-selector',
        prop: 'statuses',
        params: {
          style: 'width: 220px;',
          multiple: true,
          disabled: false,
          clearable: true,
          collapseTags: true,
          placeholder: '请选择任务状态',
          class: 'search-filter-select'
        }
      }, {
        type: 'select',
        prop: 'platforms',
        params: {
          style: 'width: 220px;',
          multiple: true,
          disabled: false,
          clearable: true,
          collapseTags: true,
          placeholder: '请选择平台',
          class: 'search-filter-select',
          options: platform
        }
      }, {
        type: 'business',
        subtype: 'interactive-channel-selector',
        prop: 'traffic_types',
        params: {
          style: 'width: 220px;',
          multiple: true,
          disabled: false,
          clearable: true,
          filterable: true,
          collapseTags: true,
          placeholder: '请选择投放渠道',
          class: 'search-filter-select'
        }
      }, {
        prop: 'languages',
        type: 'business',
        subtype: 'language-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select',
          placeholder: '请选择语言'
        }
      }, {
        prop: 'demander_ids',
        type: 'business',
        subtype: 'demander-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'account_manager_ids',
        type: 'business',
        subtype: 'account-mgr-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'planner_ids',
        type: 'business',
        subtype: 'planner-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'designer_ids',
        type: 'business',
        subtype: 'designer-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'developer_ids',
        type: 'business',
        subtype: 'developer-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          filterable: true,
          class: 'search-filter-select',
          collapseTags: true
        }
      }, {
        prop: 'adv_ids',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          multiple: true,
          filterable: true,
          collapseTags: true,
          style: 'width: 220px;',
          class: 'search-filter-select'
        }
      }, {
        prop: 'tester_ids',
        type: 'business',
        subtype: 'tester-selector',
        params: {
          multiple: true,
          filterable: true,
          collapseTags: true,
          style: 'width: 220px;',
          class: 'search-filter-select'
        }
      }, {
        prop: 'tag_ids',
        type: 'business',
        subtype: 'base-package-tag-selector',
        params: {
          placeholder: '请选择标签',
          multiple: true,
          collapseTags: true,
          style: 'width: 220px;',
          class: 'search-filter-select'
        }
      }, {
        prop: 'material_source',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: false,
          placeholder: '请选择素材来源',
          options: sourceList
        }
      },

      // 筛选供应商
      {
        prop: 'provider_ids',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: false,
          multiple: true,
          placeholder: '请选择素材供应商',
          options: this.creativeProvider
        }
      }, {
        prop: 'search_time',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: false,
          placeholder: '请选择时间类型',
          options: timeFilterOptions
        }
      }, {
        type: 'date-picker',
        subtype: 'daterange',
        prop: 'time',
        params: {
          disabled: false,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        }
      }];
    },
    innerFormList: function innerFormList() {
      var _this2 = this;

      var tempConfig = [];
      this.formItems.forEach(function (props) {
        var formItem = _this2.formItemList.find(function (item) {
          return item.prop === props;
        });
        if (formItem) {
          tempConfig.push(formItem);
        }
      });
      return tempConfig;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.$store.dispatch('config/getCreativeProvider');

            case 2:
              _this3.creativeProvider = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },


  methods: {
    exportSheet: function exportSheet() {
      var query = cookRequestParams(this.query);
      // http://playable.dev.com:8067/?doc=demand/demand.go#-demand-demand-export
      downloadWithNewWindow(v2Host + '/qa/task/export?' + qs.stringify(query));
    }
  }
};